<template>
  <div class="w-full">
    <v-col cols="12" md="6" class="mt-3">
      <button type="button" @click="show = true" class="tabs" style="text-align: center">
        Configuración de Zona
      </button>
    </v-col>
    <v-dialog v-model="show" width="40%" scrollable>
      <v-card>
        <v-card-title>Zone Configuration</v-card-title>
        <v-card-text>
          <v-row class="mt-3" style="margin-bottom: 75px">
            <v-col cols="12" md="12">
              <v-select :items="sellerZones" item-text="Name" item-value="ID_SellerZone" v-model="selectedZone"
                label="Customer Zone:" outlined attach dense @change="handleZoneChange"></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-right">
            <v-btn type="button" @click="handleContinue" class="btndisable">
              Continue
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
      <block v-if="loading" />
    </v-dialog>
    <Alert v-model="alert.show" :type="alert.type" :title="alert.title">
      {{ alert.message }}
    </Alert>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Alert from '../../../../components/Alert.vue';

export default {
  name: "ManageSellerZoneDialog",
  components: {
    Alert
  },
  props: {
    sellerId: {
      type: String,
      default: null,
    },
    sellerZoneId: {
      type: Number,
      default: null,
    }
  },
  data() {
    return {
      loading: false,
      show: false,
      selectedZone: null,
      sellerZones: [],
      alert: {
        show: false,
        type: "",
        title: "",
        message: "",
      },
    };
  },
  mounted() {
    this.getSellerZones()
    this.selectedZone = this.sellerZoneId
  },
  computed: {
    ...mapState("sysparameters", {
      sysParametersDefault: (state) => state.parameters,
    }),
  },
  methods: {
    handleZoneChange() {
      if (this.sellerId) {
        this.loading = true
        this.$API.sellerZone.relateSellerWithZone(this.sellerId, this.selectedZone)
          .then(seller => {
            this.showSuccessAlert("El Cambio correctamente la zona del vendedor.")
            this.$emit("updateSeller", seller)
            this.resetSellersWindow()
          })
          .finally(() => this.loading = false)
      }
    },
    handleContinue() {
      if (this.sellerId) {
        this.show = false;
        return;
      }
      this.$emit("select-zone", this.selectedZone);
      this.show = false;
    },
    getSellerZones() {
      this.loading = true
      this.$API.sellerZone.getSellerZones()
        .then(sellerZones => {
          if (sellerZones.length > 0) {
            this.sellerZones = sellerZones
          }
        })
        .finally(() => this.loading = false)
    },
    showSuccessAlert(message) {
      this.alert.show = true;
      this.alert.type = "success";
      this.alert.title = "Éxito";
      this.alert.message = message;
      this.getAllPayments();
    },
    resetSellersWindow() {
      this.$store.dispatch("addWindow", {
        name: "SellerList",
        component: "SellerList",
        unique: false,
      });
    }
  },
};
</script>
<style scoped>
.tabs:hover {
  background-color: rgba(80, 80, 80, 1);
  cursor: pointer;
}

.tabs {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.w-full {
  width: 100%;
}
</style>